import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { Input } from 'components/Shared';
import { FORM_BACK_ACTION } from 'constants/Common';
import type { ChecklistTemplate } from 'contracts/ChecklistTemplate';
import { useValidation } from 'hooks';
import React, { useCallback, useEffect, useRef } from 'react';
import { UpdateChecklistTemplateValidator } from 'validators/ChecklistTemplates';
import * as S from './styles';

interface Props {
  template?: ChecklistTemplate | null;
  loading?: boolean;
  onSubmit: (data: { name: string; google_id: string; slug: string }) => Promise<void>;
}

export const UpdateForm: React.FC<Props> = ({ template, loading, onSubmit }) => {
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors } = useValidation();

  useEffect(() => {
    if (!template) return;

    formRef.current?.setData({
      name: template.name,
      google_id: template.google_id,
      slug: template.slug || '',
    });
  }, [template]);

  const handleSubmit = useCallback(
    async (data: any): Promise<void> => {
      try {
        formRef.current?.setErrors({});
        const { schema } = new UpdateChecklistTemplateValidator();
        const validData = await schema.validate(data, { abortEarly: false });
        await onSubmit({
          name: validData.name,
          google_id: validData.google_id,
          slug: validData.slug,
        });
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [handleFormErrors, onSubmit]
  );

  return (
    <S.Container>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <S.FormRow>
          <Input name="name" label="Nome" />
        </S.FormRow>
        <S.FormRow>
          <Input
            name="google_id"
            label="Google Form ID ou URL"
            placeholder="Cole o ID ou URL do Google Forms"
          />
        </S.FormRow>
        <S.HelperText>
          Exemplo: https://docs.google.com/forms/d/e/SEU_ID/viewform
        </S.HelperText>
        <S.FormRow>
          <Input
            name="slug"
            label="Slug"
            placeholder="Ex.: entrada-terceiros"
          />
        </S.FormRow>
        <S.Notice>
          Alterações no nome, slug ou Google Form ID não afetam checklists já
          respondidos.
        </S.Notice>
        <S.FormActions>
          <S.LinkButton mood="light" to="/configuracoes/checklist/modelos">
            {FORM_BACK_ACTION}
          </S.LinkButton>
          <S.Button type="submit" disabled={loading || !template}>
            {loading ? <S.ActivityIndicator /> : 'Salvar'}
          </S.Button>
        </S.FormActions>
      </Form>
    </S.Container>
  );
};
